'use client';
import { getDisplayMeetingStatus, MeetingStatus, } from '@govinity/validation';
import { formatDateTime, formatMeetingDate, formatMeetingDateTime, } from '@govinity/shared-config';
import { cn } from '../../lib/utils.js';
import { LiveTimer } from './live-timer';
export var MeetingStatusInfo = function (_a) {
    var className = _a.className, meeting = _a.meeting, timezone = _a.timezone;
    var classes = cn('text-muted-foreground text-sm', className);
    var displayStatus = getDisplayMeetingStatus({
        date: meeting.date,
        status: meeting.status,
        timezone: timezone,
    });
    if (displayStatus === MeetingStatus.Cancelled) {
        return (<div>
        <p className={classes}>
          Cancelled:&nbsp;
          {formatMeetingDateTime(meeting.cancelledAt, timezone)}
        </p>
      </div>);
    }
    if (displayStatus === MeetingStatus.Live) {
        var streamScheduledEndDate = 'streamScheduledEndDate' in meeting ? meeting.streamScheduledEndDate : null;
        return (<div>
        <p className={classes}>
          {streamScheduledEndDate ? 'Live • Remaining:' : 'Live • Started:'}&nbsp;
          <LiveTimer endTime={streamScheduledEndDate} mode={streamScheduledEndDate ? 'countdown' : 'elapsed'} startTime={String(meeting.startedAt)}/>
        </p>
      </div>);
    }
    if (displayStatus === MeetingStatus.Completed) {
        // Completed because the meeting's day has passed rather than because it was run through the
        // clerk console, so there is no recorded start or finish to report.
        if (!meeting.completedAt) {
            return (<div>
          <p className={classes}>Completed</p>
        </div>);
        }
        if (meeting.startedAt) {
            return (<div>
          <p className={classes}>
            <span className="block sm:inline">
              Started:&nbsp;
              {formatDateTime(meeting.startedAt, { appendTimezone: true, timezone: timezone })}
            </span>
            <span className="hidden sm:inline"> | </span>
            <span className="block sm:inline">
              Completed:&nbsp;
              {formatDateTime(meeting.completedAt, { appendTimezone: true, timezone: timezone })}
            </span>
          </p>
        </div>);
        }
        return (<div>
        <p className={classes}>Completed: {formatMeetingDate(meeting.completedAt)}</p>
      </div>);
    }
    return (<div>
      <p className={classes}>Upcoming</p>
    </div>);
};
